import enMessages from './locales/en_US.json';
import frMessages from './locales/fr_CA.json';
import deMessages from './locales/de.json';
import esMessages from './locales/es.json';
import itMessages from './locales/it.json';
import fiMessages from './locales/fi.json';
import svMessages from './locales/sv.json';
import noMessages from './locales/no.json';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

i18n.use(LanguageDetector).init({
  fallbackLng: 'en',
  supportedLngs: ['en', 'fr', 'de', 'es', 'it', 'fi', 'sv', 'no'],
  nonExplicitSupportedLngs: true,
  resources: {
    en: {
      app: enMessages,
    },
    fr: {
      app: frMessages,
    },
    de: {
      app: deMessages,
    },
    es: {
      app: esMessages,
    },
    it: {
      app: itMessages,
    },
    fi: {
      app: fiMessages,
    },
    sv: {
      app: svMessages,
    },
    no: {
      app: noMessages,
    },
  },

  debug: false,
  ns: ['app'],
  defaultNS: 'app',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

export default i18n;
